import { ConsoleWriter } from '../writers/console-writer';
import { Injectable } from '@angular/core';
import { LogConfigService } from './log-config.service';
import { LogLevel } from '../models/log-level.enum';
import { LogWriter } from '../writers/log-writer';

@Injectable()
export class DefaultLogConfigService implements LogConfigService {
    public getLogLevel(): LogLevel {
        return LogLevel.Warn;
    }
    public getLogWriters(): LogWriter[] {
        return [
            new ConsoleWriter()
        ];
    }
}
